module.exports = __webpack_public_path__ + "static/media/poster-balconies.8c670878.jpg";